import { SVGProps, Ref, forwardRef } from 'react';

export const PenHyperstarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.672 2.258a4.292 4.292 0 1 1 6.07 6.07L7.072 23H1v-6.071zM2.8 17.675V21.2h3.525L17.626 9.9l-3.525-3.526zM20.47 3.53a2.493 2.493 0 0 0-3.526 0l-1.57 1.57 3.525 3.526 1.57-1.57a2.493 2.493 0 0 0 0-3.526"
                fill="currentColor"
            />
            <path
                d="M4.5 1A13.3 13.3 0 0 0 8 4.5 13.3 13.3 0 0 0 4.5 8 13.3 13.3 0 0 0 1 4.5 13.3 13.3 0 0 0 4.5 1"
                fill="currentColor"
            />
        </g>
    </svg>
));
PenHyperstarOutlinedSize24Glyph.displayName = 'PenHyperstarOutlinedSize24Glyph';
